function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import "../../../../../enums/accordion.js";
import "../../../../../enums/alert.js";
import "../../../../../enums/avatar.js";
import "../../../../../enums/breakpoints.js";
import "../../../../../enums/button.js";
import "../../../../../enums/code-editor.js";
import "../../../../../enums/colors.js";
import "../../../../../enums/combobox.js";
import "../../../../../enums/date.js";
import "../../../../../enums/drag-and-drop.js";
import "../../../../../enums/dialog.js";
import "../../../../../enums/divider.js";
import "../../../../../enums/dropdown.js";
import "../../../../../enums/fieldset.js";
import "../../../../../enums/font-icon.js";
import "../../../../../enums/fonts.js";
import "../../../../../enums/headings.js";
import "../../../../../enums/input.js";
import "../../../../../enums/keys.js";
import "../../../../../enums/list.js";
import "../../../../../enums/listbox.js";
import "../../../../../enums/loader.js";
import "../../../../../enums/margin.js";
import "../../../../../enums/option.js";
import "../../../../../enums/pill.js";
import "../../../../../enums/placements.js";
import "../../../../../enums/popout.js";
import "../../../../../enums/privacy.js";
import "../../../../../enums/radio-group.js";
import "../../../../../enums/status.js";
import { SwitchVariant } from "../../../../../enums/switch.js";
import "../../../../../enums/table.js";
import "../../../../../enums/tooltip.js";
import "../../../../../enums/transitions.js";
import "../../../../../enums/widths.js";
import { BaseSwitch } from "../base/base-switch.js";
import styleClasses from "./standard-switch.module.scss.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/**
 * DEPRECATED: Use `CheckboxSwitch` or `ImmediateSwitch` instead.
 *
 * @deprecated Use `CheckboxSwitch` or `ImmediateSwitch` instead.
 */
var StandardSwitch = function StandardSwitch(props) {
  var baseProps = _objectSpread(_objectSpread({}, props), {}, {
    styleClasses: styleClasses,
    variantName: SwitchVariant.Standard
  });
  return /*#__PURE__*/React.createElement(BaseSwitch, _extends({}, baseProps));
};
export { StandardSwitch };